<template>
  <section class="bg-[#25006b] py-20 px-4 text-white  mt-20 pb-32">
    <div class="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mt-16 pb-18">
      <!-- Texto à esquerda -->
      <div>
        <h2 class="text-4xl font-semibold mb-4">Qualidade e preço justo!</h2>
        <h3 class="text-lg font-bold mb-4">
          Servidores de alto desempenho com SSD NVMe de 4ª geração
        </h3>
        <p class="text-base leading-relaxed">
          Fornecemos não só uma hospedagem, mas um conjunto de ferramentas exclusivas
          para facilitar o seu trabalho e apoio de especialistas em várias áreas
          para entender o seu negócio.
        </p>
      </div>

      <!-- Cards à direita -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div class="bg-[#25266a] p-6 rounded-xl text-center">
          <img src="/icones-home-qualidade/qualidade-1.svg" alt="Suporte" class="mx-auto h-24 mb-8 my-8" />
          <h4 class="font-semibold">Suporte</h4>
          <p class="text-sm">24 horas todos os dias</p>
        </div>
        <div class="bg-[#25266a] p-6 rounded-xl text-center">
          <img src="/icones-home-qualidade/qualidade-2.svg" alt="Uptime" class="mx-auto h-24 mb-8 my-8" />
          <h4 class="font-semibold">99.99%<br />Uptime Garantido!</h4>
        </div>
        <div class="bg-[#25266a] p-6 rounded-xl text-center">
          <img src="/icones-home-qualidade/qualidade-3.svg" alt="Monitoramento" class="mx-auto h-24 mb-8 my-8" />
          <h4 class="font-semibold">Monitoramento</h4>
          <p class="text-sm">24 horas todos os dias</p>
        </div>
        <div class="bg-[#25266a] p-6 rounded-xl text-center">
          <img src="/icones-home-qualidade/qualidade-4.svg" alt="14 dias grátis" class="mx-auto h-24 mb-8 my-8" />
          <h4 class="font-semibold">14 dias grátis</h4>
          <p class="text-sm">Exceto VPS e Dedicado</p>
        </div>
      </div>
    </div>
  </section>
</template>
